import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface StatCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  color: "yellow" | "cyan" | "pink" | "blue";
  description?: string;
  trend?: {
    value: number;
    label: string;
  };
  onClick?: () => void;
}

export function StatCard({ title, value, icon: Icon, color, description, trend, onClick }: StatCardProps) {
  const colorMap = {
    yellow: "bg-[#FFD93D]",
    cyan: "bg-[#6FEDD6]",
    pink: "bg-[#FF6B9D]",
    blue: "bg-[#4DA6FF]",
  };

  return (
    <div 
      onClick={onClick}
      className={cn(
        "flex flex-col rounded-xl border-2 border-black p-6 shadow-[4px_4px_0_#000] transition-all hover:translate-x-[-2px] hover:translate-y-[-2px] hover:shadow-[6px_6px_0_#000]",
        colorMap[color],
        onClick && "cursor-pointer"
      )}
    >
      <div className="flex items-start justify-between">
        <div className="space-y-1">
          <p className="text-xs font-black uppercase tracking-wider opacity-60 text-black">{title}</p>
          <h3 className="text-4xl font-black tracking-tight">{value}</h3>
        </div>
        <div className="flex h-12 w-12 items-center justify-center rounded-xl border-2 border-black bg-white shadow-[2px_2px_0_#000]">
          <Icon className="h-6 w-6" />
        </div>
      </div>
      
      {(description || trend) && (
        <div className="mt-4 flex items-center gap-2 text-sm font-medium">
          {trend && (
             <span className={cn(
               "flex items-center rounded-full border-2 border-black bg-white px-2 py-0.5 text-xs font-bold",
               trend.value >= 0 ? "text-green-600" : "text-red-600"
             )}>
               {trend.value >= 0 ? "+" : ""}{trend.value}%
             </span>
          )}
          {description && <span className="opacity-70">{description}</span>}
        </div>
      )}
    </div>
  );
}
